export default (responseError, errorMessageMap = {}, genericErrorMessage = 'An error occurred') => {
    if (responseError.errors && responseError.errors.length) {
        const error = responseError.errors[0];
        return error.code ? errorMessageMap[error.code] :
            (error.title || genericErrorMessage);
    }
    return genericErrorMessage;
}



// WEBPACK FOOTER //
// ./src/app/errors/json-api-error-handler.js